<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h5 class="mb-0 h6">{{ $t("提款银行卡") }}</h5>
      </div>
      <div class="card-body">
        <div class="row gutters-10">
          <div v-for="(item, index) in list" :key="index" class="col-md-6 mb-3">
            <div class="aiz-megabox d-block bg-white mb-0">
              <div class="d-flex p-3 aiz-megabox-elem">
                <div class="flex-grow-1 pl-3 text-left">
                  <div>
                    <span class="opacity-60">{{ $t("卡号类型") }}：</span>
                    <span class="fw-600 ml-2">{{ item.cardType }}</span>
                  </div>
                  <div v-if="item.bankUsername">
                    <span class="opacity-60">{{ $t("Account_Name") }}：</span>
                    <span class="fw-600 ml-2"> {{ item.bankUsername }}</span>
                  </div>
                  <div v-if="item.bankAccount">
                    <span class="opacity-60">{{ $t("Bank_Account") }}：</span>
                    <span class="fw-600 ml-2"> {{ item.bankAccount }}</span>
                  </div>
                  <div v-if="item.bankPhone">
                    <span class="opacity-60">{{ $t("Bank_Phone") }}：</span>
                    <span class="fw-600 ml-2">{{ item.bankPhone }}</span>
                  </div>
                  <div v-if="paramMapAll['BANK_ACCOUNT1_OPEN'] === '1'">
                    <span class="opacity-60">{{ $t(paramMapAll['BANK_ACCOUNT1_NAME']) }}：</span>
                    <span class="fw-600 ml-2"> {{ item.bankAccount1 }}</span>
                  </div>
                  <div v-if="paramMapAll['BANK_ACCOUNT2_OPEN'] === '1'">
                    <span class="opacity-60">{{ $t(paramMapAll['BANK_ACCOUNT2_NAME']) }}：</span>
                    <span class="fw-600 ml-2"> {{ item.bankAccount2 }}</span>
                  </div>
                  <div v-if="item.usdt">
                    <span class="opacity-60">{{ $t("钱包地址") }}：</span>
                    <span class="fw-600 ml-2">{{ item.usdt }}</span>
                  </div>
                  <div v-if="item.idCard">
                    <span class="opacity-60">{{ $t("身份证号") }}：</span>
                    <span class="fw-600 ml-2">{{ item.idCard }}</span>
                  </div>
                  <div style="margin-top: 5px;">
                    <el-button
                      v-if="'1' === paramMapAll['USER_BANK_CARD_EDIT_OPEN']"
                      size="mini"
                      type="primary"
                      @click="edit(item)"
                      >{{ $t("Edit") }}
                    </el-button>
                    <el-button
                      v-if="'1' === paramMapAll['USER_BANK_CARD_DELETE_OPEN']"
                      size="mini"
                      type="danger"
                      @click="del(item.id)"
                      >{{ $t("Delete") }}
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="list.length < paramMapAll['USER_BANK_CARD_LIMIT']"
            class="col-md-6 mx-auto mb-3"
            @click="add()"
          >
            <div
              class="border p-3 rounded mb-3 c-pointer text-center bg-white h-100 d-flex flex-column justify-content-center"
            >
              <i class="las la-plus la-2x mb-3"></i>
              <div class="alpha-7">{{ $t(`Add`) }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="text-red"
      style="padding: 10px;"
      v-html="paramMapAll['BANK_TIPS']"
      v-if="paramMapAll['BANK_TIPS']"
    />

    <van-dialog
      v-model="show"
      :show-confirm-button="false"
      :title="$t('Bank_Card_Info')"
      close-on-click-overlay
    >
      <van-form @submit="saveBank">
        <van-field :label="$t('卡号类型')" name="radio">
          <template #input>
            <van-radio-group
              v-model="bankInfo.cardType"
              class="ft-12"
              direction="horizontal"
            >
              <template v-if="card_types && card_types.length > 0">
                <van-radio
                  v-for="cardType in card_types"
                  :key="cardType"
                  :name="cardType"
                  icon-size="12px"
                >
                  {{ cardType }}
                </van-radio>
              </template>
              <template v-else>
                <van-radio
                  v-if="
                    paramMapAll['BANK_ACCOUNT_OPEN'] === '1' &&
                      paramMapAll['SYSTEM_COUNTRY'] != 'ARG'
                  "
                  icon-size="12px"
                  name="BANK"
                >
                  BANK
                </van-radio>
                <template v-if="paramMapAll['BANK_USDT_OPEN'] === '1'">
                  <van-radio icon-size="12px" name="USDT-trc20"
                    >USDT-trc20
                  </van-radio>
                  <van-radio icon-size="12px" name="USDT-erc20"
                    >USDT-erc20
                  </van-radio>
                </template>
                <template v-if="paramMapAll['BANK_PIX_OPEN'] === '1'">
                  <van-radio icon-size="12px" name="CPF">CPF</van-radio>
                  <van-radio icon-size="12px" name="CNPJ">CNPJ</van-radio>
                  <van-radio icon-size="12px" name="PHONE">PHONE</van-radio>
                  <van-radio icon-size="12px" name="EMAIL">EMAIL</van-radio>
                  <van-radio icon-size="12px" name="EVP">EVP</van-radio>
                </template>
                <template v-if="paramMapAll['SYSTEM_COUNTRY'] === 'ARG'">
                  <van-radio icon-size="12px" name="Mercado"
                    >Mercado
                  </van-radio>
                  <van-radio icon-size="12px" name="Uala">Uala</van-radio>
                  <van-radio icon-size="12px" name="CBU">CBU</van-radio>
                  <van-radio icon-size="12px" name="CVU">CVU</van-radio>
                </template>
              </template>
            </van-radio-group>
          </template>
        </van-field>
        <template v-if="bankInfo.cardType && ['USDT','TRX','trc'].find(str=>bankInfo.cardType.includes(str))">
          <!--          v-if="paramMap['BANK_USDT_OPEN'] === '1'"-->
          <van-field
              v-if="paramMapAll['BANK_USDT_OPEN'] === '1'"
              v-model.trim="bankInfo.usdt"
              :label="$t('钱包地址')"
              :placeholder="$t('钱包地址')"
              :rules="[{ required: true, message: $t('please_input') }]"
          />
        </template>
        <template v-else>
        <van-field
          v-if="paramMapAll['BANK_USERNAME_OPEN'] === '1'"
          v-model.trim="bankInfo.bankUsername"
          :label="$t('Account_Name')"
          :placeholder="$t('please_input') + $t('Account_Name')"
          :rules="[
            {
              required: true,
              message: $t(`please_input`) + $t('Account_Name')
            }
          ]"
        />
        <van-field
          v-if="paramMapAll['USER_ADDRESS_OPEN'] === '1'"
          v-model.trim="bankInfo.userAddress"
          :label="$t('收款人地址')"
          :placeholder="$t('please_input') + $t('收款人地址')"
          :rules="[
            {
              required: true,
              message: $t(`please_input`) + $t('收款人地址')
            }
          ]"
        />
        <van-field
          v-if="paramMapAll['SWIFT_OPEN'] === '1'"
          v-model.trim="bankInfo.swift"
          :label="$t('SWIFT')"
          :placeholder="$t('please_input') + $t('SWIFT')"
          :rules="[
            {
              required: true,
              message: $t(`please_input`) + $t('SWIFT')
            }
          ]"
        />
        <van-field
          v-if="paramMapAll['BANK_PHONE_OPEN'] === '1'"
          v-model.trim="bankInfo.bankPhone"
          :label="$t('Bank_Phone')"
          :placeholder="$t('please_input') + $t('Bank_Phone')"
          :rules="[
            {
              required: true,
              message: $t(`please_input`) + $t('Bank_Phone')
            }
          ]"
        />
        <van-field
          v-if="paramMapAll['BANK_BRANCH_NAME_OPEN'] === '1'"
          v-model.trim="bankInfo.bankBranchName"
          :label="$t('Bank_Branch')"
          :placeholder="$t('please_input') + $t('Bank_Branch')"
          :rules="[
            {
              required: true,
              message: $t(`please_input`) + $t('Bank_Branch')
            }
          ]"
        />
        <van-field
          v-if="paramMapAll['BANK_BRANCH_CODE_OPEN'] === '1'"
          v-model.trim="bankInfo.bankBranchCode"
          :label="$t('分行代码')"
          :placeholder="$t('please_input') + $t('分行代码')"
          :rules="[
            {
              required: true,
              message: $t(`please_input`) + $t('分行代码')
            }
          ]"
        />
        <van-field
          v-if="paramMapAll['BANK_ADDRESS_OPEN'] === '1'"
          v-model.trim="bankInfo.bankAddress"
          :label="$t('银行地址')"
          :placeholder="$t('please_input') + $t('银行地址')"
          :rules="[
            {
              required: true,
              message: $t(`please_input`) + $t('银行地址')
            }
          ]"
        />

        <template v-if="paramMapAll['BANK_NAME_OPEN'] === '1'">
          <van-field
            v-model="bankInfo.bankName"
            :label="$t('Bank_Name')"
            :placeholder="$t('please_input') + $t('Bank_Name')"
            clickable
            name="picker"
            @click="clickBankInput()"
          />
          <van-popup v-model="showBankPicker" position="bottom">
            <van-picker
              :columns="bank_list"
              show-toolbar
              @cancel="showBankPicker = false"
              @confirm="onConfirmBank"
            />
          </van-popup>
        </template>
        <template v-if="paramMapAll['BANK_ACCOUNT_OPEN'] === '1'">
          <van-field
            v-if="paramMapAll['BANK_ACCOUNT_OPEN'] === '1'"
            v-model.trim="bankInfo.bankAccount"
            :label="$t('Bank_Account')"
            :placeholder="$t('please_input') + $t('Bank_Account')"
            :rules="[
              {
                required: true,
                message: $t(`please_input`) + $t('Bank_Account')
              }
            ]"
          />
          <!--                        <van-field-->
          <!--                            v-model.trim="bankInfo.reBankAccount"-->
          <!--                            :label="$t('Bank_Account_Confirm')"-->
          <!--                            :placeholder="$t('please_input')+$t('Bank_Account_Confirm')"-->
          <!--                            :rules="[{ required: true, message: $t(`please_input`)+$t('Bank_Account_Confirm') }]"-->
          <!--                        />-->
        </template>
        <van-field
          v-if="paramMapAll['BANK_ACCOUNT1_OPEN'] === '1'"
          v-model.trim="bankInfo.bankAccount1"
          :label="$t(paramMapAll['BANK_ACCOUNT1_NAME'])"
          :placeholder="$t('please_input') + $t(paramMapAll['BANK_ACCOUNT1_NAME'])"
          :rules="[
            {
              required: true,
              message: $t(`please_input`) + $t(paramMapAll['BANK_ACCOUNT1_NAME'])
            }
          ]"
        />
        <van-field
          v-if="paramMapAll['BANK_ACCOUNT2_OPEN'] === '1'"
          v-model.trim="bankInfo.bankAccount2"
          :label="$t(paramMapAll['BANK_ACCOUNT2_NAME'])"
          :placeholder="$t('please_input') + $t(paramMapAll['BANK_ACCOUNT2_NAME'])"
          :rules="[
            {
              required: true,
              message: $t(`please_input`) + $t(paramMapAll['BANK_ACCOUNT2_NAME'])
            }
          ]"
        />

        <van-field
          v-if="paramMapAll['BANK_EMAIL_OPEN'] === '1'"
          v-model.trim="bankInfo.email"
          :label="$t('Email')"
          :placeholder="$t('please_input') + $t('Email')"
          :rules="[
            {
              required: true,
              message: $t(`please_input`) + $t('Email')
            }
          ]"
        />
        <van-field
          v-if="paramMapAll['BANK_ID_CARD_OPEN'] === '1'"
          v-model.trim="bankInfo.idCard"
          :label="$t('身份证号')"
          :placeholder="$t('please_input') + $t('身份证号')"
          :rules="[{ required: true, message: $t('please_input') }]"
        />
        </template>

        <van-field
          v-model.trim="bankInfo.tkPassword"
          :label="$t('提款密码')"
          :placeholder="$t('please_input') + $t('提款密码')"
          :rules="[
            {
              required: true,
              message: $t('please_input_withdraw_password')
            },
            {
              pattern: /^.{4,16}$/,
              message: $t('withdraw_password_format_error'),
              trigger: 'blur'
            }
          ]"
          type="password"
        />
        <div style="margin: 16px;">
          <van-button
            :loading="loading"
            :loading-text="$t('submitting')"
            block
            native-type="submit"
            round
            small
            type="primary"
          >
            {{ $t("submit") }}
          </van-button>
        </div>
      </van-form>
      <div
        class="text-red"
        style="padding: 10px;"
        v-html="paramMapAll['BANK_TIPS']"
      ></div>
    </van-dialog>
  </div>
</template>

<script>
import * as BankCardApi from "@/api/user.bankCard";

export default {
  data() {
    return {
      show: false,
      bankInfo: { cardType: "BANK" },
      card_types: [],

      finished: false,
      loading: false,
      list: [],

      bank_list: [],
      showBankPicker: false
    };
  },
  computed: {
    ...Vuex.mapGetters(["paramMapAll"])
  },
  methods: {
    async getList() {
      this.list = (await BankCardApi.getList()).data || [];
    },
    getBankList() {
      this.bank_list = this.paramMapAll["WITHDRAW_BANK_LIST"].split("\n");
    },
    getCardTypes() {
      const cardTypes = this.paramMapAll["BANK_CARD_TYPES"];
      if (cardTypes) {
        this.card_types = cardTypes.split(",");
        this.bankInfo.cardType = this.card_types[0];
      }
    },

    add() {
      this.show = true;
    },
    del(id) {
      this.$dialog
        .confirm({
          message: this.$t("Do_you_confirm_delete")
        })
        .then(() => {
          BankCardApi.del(id).then(() => {
            this.getList();
          });
        });
    },
    edit(bank) {
      this.bankInfo = bank;
      this.bankInfo.reBankAccount = bank.bankAccount;
      this.show = true;
    },

    onConfirmBank(bankName) {
      this.bankInfo.bankName = bankName;
      this.showBankPicker = false;
    },
    clickBankInput() {
      if (this.bank_list != null && this.bank_list.length) {
        this.showBankPicker = true;
      }
    },
    saveBank() {
      if (this.bankInfo.bankAccount) {
        if (
          this.paramMapAll["SYSTEM_VERSION"] === "L_47" &&
          this.bankInfo.bankAccount.length !== 18
        ) {
          this.$toast.fail(this.$t("银行卡长度必须超过", { length: 18 }));
          return;
        }
        // 南非 14或16或者18
        if (
          this.paramMapAll["SYSTEM_COUNTRY"] === "MEX" &&
          !/^(\d{14}|\d{16}|\d{18})$/.test(this.bankInfo.bankAccount)
        ) {
          this.$toast.fail(this.$t("银行卡格式不正确"));
          return;
        }
      }
      BankCardApi.save(this.bankInfo).then(res => {
        if (res.code === 0) {
          this.$toast.success(this.$t("save_success"));
          this.show = false;
          this.getList();
        } else {
          this.$toast.fail(res.msg);
        }
      });
    }
  },
  created() {
    this.getList();
    this.getBankList();
    this.getCardTypes();
  }
};
</script>
